var _defs, _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.687 13.3l-3.346.381c-.066.008-.111-.071-.082-.139l2.952-6.493A.08.08 0 0111.282 7h3.643c.069 0 .108.09.066.154l-2.632 3.729c-.046.064 0 .162.071.154l3.23-.369c.074-.007.12.095.068.159L9.73 18.968c-.065.08-.173-.007-.134-.105l2.172-5.431c.026-.064-.02-.14-.081-.132z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleFlash);
export default __webpack_public_path__ + "static/media/bubble-flash.535173b2.svg";
export { ForwardRef as ReactComponent };